var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "skill-assessment-specs" },
    [
      _vm.skillAssessmentSpecs.length > 0
        ? _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.skillAssessmentSpecs, function(skillAssessmentSpec, i) {
        return _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
          skillAssessmentSpec.id
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: skillAssessmentSpec.id,
                    expression: "skillAssessmentSpec.id"
                  }
                ],
                attrs: {
                  name: "skill_assessment_specs[" + i + "][id]",
                  type: "hidden",
                  required: ""
                },
                domProps: { value: skillAssessmentSpec.id },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(skillAssessmentSpec, "id", $event.target.value)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "cell pl-10 pr-0 ml-6 small-2 large-2" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: skillAssessmentSpec.title,
                  expression: "skillAssessmentSpec.title"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                name: "skill_assessment_specs[" + i + "][title]",
                type: "text",
                required: ""
              },
              domProps: { value: skillAssessmentSpec.title },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(skillAssessmentSpec, "title", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell pl-4 pr-0 ml-1 small-2 large-2" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: skillAssessmentSpec.method,
                    expression: "skillAssessmentSpec.method"
                  }
                ],
                attrs: {
                  disabled: _vm.disabled,
                  name: "skill_assessment_specs[" + i + "][method]",
                  required: ""
                },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      skillAssessmentSpec,
                      "method",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "classmarker" } }, [
                  _vm._v("Classmarker")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "lms" } }, [_vm._v("LMS")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "on_prem" } }, [
                  _vm._v("On Premesis")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "other" } }, [_vm._v("Other")])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cell pl-4 pr-0 ml-1 small-2 large-2" },
            [
              skillAssessmentSpec.method === "classmarker"
                ? [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              skillAssessmentSpec.classmarker_assessment_id,
                            expression:
                              "skillAssessmentSpec.classmarker_assessment_id"
                          }
                        ],
                        attrs: {
                          disabled: _vm.disabled,
                          name:
                            "skill_assessment_specs[" +
                            i +
                            "][classmarker_assessment_id]",
                          required: ""
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              skillAssessmentSpec,
                              "classmarker_assessment_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.classmarkerAssessments, function(
                        classmarkerAssessment
                      ) {
                        return _c(
                          "option",
                          { domProps: { value: classmarkerAssessment.id } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(classmarkerAssessment.title) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        name: "skill_assessment_specs[" + i + "][benchmark]",
                        value: "",
                        type: "hidden"
                      }
                    })
                  ]
                : [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: skillAssessmentSpec.benchmark,
                          expression: "skillAssessmentSpec.benchmark"
                        }
                      ],
                      attrs: {
                        disabled: _vm.disabled,
                        name: "skill_assessment_specs[" + i + "][benchmark]",
                        required: ""
                      },
                      domProps: { value: skillAssessmentSpec.benchmark },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            skillAssessmentSpec,
                            "benchmark",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        name:
                          "skill_assessment_specs[" +
                          i +
                          "][classmarker_assessment_id]",
                        value: "",
                        type: "hidden"
                      }
                    })
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cell pl-4 ml-1 pr-0 pl-0 w-auto" }, [
            !_vm.disabled
              ? _c(
                  "div",
                  {
                    staticClass: "remove-button",
                    on: {
                      click: function() {
                        return _vm.removeSkillAssessmentSpec(i)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-minus-circle" })]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cell pl-4 pr-0 ml-1 auto" },
            [
              _vm.disabled
                ? _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: skillAssessmentSpec.instructions,
                        expression: "skillAssessmentSpec.instructions"
                      }
                    ],
                    attrs: {
                      disabled: _vm.disabled,
                      name: "skill_assessment_specs[" + i + "][instructions]",
                      placeholder: "Enter instructions...",
                      type: "text",
                      rows: "4"
                    },
                    domProps: { value: skillAssessmentSpec.instructions },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          skillAssessmentSpec,
                          "instructions",
                          $event.target.value
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.disabled
                ? _c("RedactorControl", {
                    attrs: {
                      name: "skill_assessment_specs[" + i + "][instructions]",
                      value: skillAssessmentSpec
                        ? skillAssessmentSpec.instructions
                        : "",
                      rows: "5"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      }),
      _vm._v(" "),
      !_vm.disabled
        ? _c(
            "div",
            {
              staticClass: "add-button",
              on: { click: _vm.addSkillAssessmentSpec }
            },
            [_c("i", { staticClass: "fas fa-plus-circle" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.skillAssessmentSpecs.length === 0
        ? _c("input", {
            attrs: { name: "skill_assessment_specs", value: "", type: "hidden" }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-10 ml-6 pr-0 small-2 large-2" }, [
      _c("label", [_vm._v("Assessment Type:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-4 ml-1 pr-0 small-2 large-2" }, [
      _c("label", [_vm._v("Method:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-4 ml-1 pr-0 small-2 large-2" }, [
      _c("label", [_vm._v("Benchmark:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-4 ml-1 pr-0 small-1 large-1" }, [
      _c("label")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-4 ml-1 pr-0 small-2 large-2" }, [
      _c("label", [_vm._v("Instructions:")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0b4fe0a", { render: render, staticRenderFns: staticRenderFns })
  }
}